import {connect, useSelector} from 'react-redux';

export function useCredentials() {
  return useSelector(state => state.credentials);
}

export function useUser() {
  return useSelector(state => state.user);
}

export function useSignedIn() {
  return useSelector(state => state.signedIn);
}

export function withUser(Component, {userProp = 'user', credentialsProp = 'credentials', signedInProp = 'signedIn'} = {}) {
  return connect(state => ({
    [userProp]: state.user, 
    [credentialsProp]: state.credentials,
    [signedInProp]: state.signedIn,
  }))(Component);
}

export function getSetting(user, key) {
  if (!user.settings) {
    return null;
  }

  return user.settings.filter(setting => setting.key === key)[0];
}